import Vote from './Vote.vue'

export default Vote
